import {
  GET_RATE_CARD_DATA,
  CREATE_RATE_CARD_DATA,
  LOADING,
} from "./rateCardType";

const initialState: any = {
  data: [],
  loading: false,
};

export default function rateCardReducer(state = initialState, action: any) {
  switch (action.type) {
    case CREATE_RATE_CARD_DATA:
      return {
        ...state,
        data: action.payload,
      };

    case GET_RATE_CARD_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}
